import { Component, OnInit, Input, TemplateRef, ViewChild, ViewChildren } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { ImageLibrary } from "../Models/ImageLibrary";
import { PHBHPFeaturePackageConfigurationService } from "../ph-bhp-feature-package-configuration.service";
import { PHBHPLayoutPackageService } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: "app-ph-bhp-configure-image-library",
  templateUrl: "./ph-bhp-configure-image-library.component.html",
  styleUrls: ["./ph-bhp-configure-image-library.component.css"]
})
export class PhBhpConfigureImageLibraryComponent implements OnInit {

  @ViewChild("ngForm") ngForm
  collapseExample = false;
  public imagePath;
  imageURL: any;
  searchText;
  public message: string;
  addImageForm: UntypedFormGroup;
  ImageData: Array<ImageLibrary>;
  imageId: any = null;
  URL: string;
  serverUrl;
  index;
  isPreview = true
  userData;
  @ViewChild('sopWrapper') sopWrapper;
  @ViewChild('newImage') newImage;
  @ViewChildren('cdkDragList') cdkDragList;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  deleteImage;
  @ViewChild('arrw') arrw;
  @ViewChild('arrwShadow') arrwShadow;
  imageLibDescriptionMaxlength = 500;
  imagenameLength = 40;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  public items: any[] = [];
  formatTexts: any[] = [];

  constructor(
    private modalService: BsModalService,
    private router: Router,
    public translate: TranslateService,
    private http: HttpClient,
    private service: PHBHPFeaturePackageConfigurationService,
    public layoutService: PHBHPLayoutPackageService,
    public appConfig: AppConfig
  ) {
    this.serverUrl = layoutService.serverUrl;
  }

  ngOnInit() {
    this.addImageForm = new UntypedFormGroup({
      imageName: new UntypedFormControl("", Validators.compose([Validators.required])),
      description: new UntypedFormControl(
        "",
        Validators.compose([Validators.required])
      ),
      tags: new UntypedFormControl(""),
      imageURL: new UntypedFormControl("", Validators.compose([Validators.required]))
    });
    this.getImageList();

    var formatText = this.layoutService.translateText('CONFIGURE.JPG_OR_PNG_800X500');
    this.formatTexts = formatText.split('|');
    if (this.formatTexts.length == 1) {
      this.formatTexts = formatText.split('/');
    }
  }

  saveImage() {
    this.imagePath = null;
    this.imageId = null;
    this.imageURL = null;
    this.index = null;
    this.ngForm.submitted = false;
    this.ngForm.reset();
    this.addImageForm.reset();
  }
  openWrapper(index) {
    this.items = [];
    this.cdkDragList.forEach(cdkDrag => cdkDrag.nativeElement.classList.remove('active'));
    this.newImage.nativeElement.classList.remove('active');
    var phElement = this.cdkDragList._results[index].nativeElement;
    phElement.classList.add('active');
    var x = phElement.offsetTop + 115;
    var y = phElement.offsetLeft;
    this.sopWrapper.nativeElement.style.top = x + 'px';
    this.sopWrapper.nativeElement.style.left = '0px';
    this.arrw.nativeElement.style.left = y + 35 + 'px';
    this.arrwShadow.nativeElement.style.left = y + 33 + 'px';
    this.collapseExample = true;
    this.index = index;
    this.editImage(this.ImageData[index])
  }
  openNewWrapper() {
    this.items = [];
    this.cdkDragList.forEach(cdkDrag => cdkDrag.nativeElement.classList.remove('active'));
    // this.newImage.nativeElement.classList.add('active');
    var x = this.newImage.nativeElement.offsetTop + 130;
    var y = this.newImage.nativeElement.offsetLeft;
    this.sopWrapper.nativeElement.style.top = x + 'px';
    this.sopWrapper.nativeElement.style.left = '0px';
    this.arrw.nativeElement.style.left = y + 35 + 'px';
    this.arrwShadow.nativeElement.style.left = y + 33 + 'px'
    this.collapseExample = true;
    this.saveImage()
  }
  toggleSingleSOP() {
    this.collapseExample = false;
  }
  preview(files) {
    if (files.length === 0) return;
    this.isPreview = true;
    var reader = new FileReader();
    this.imagePath = files;
    if (this.imagePath[0].size > 1000000) {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.IMAGE_SIZE_TOO_BIG'));
    } else {
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imageURL = reader.result;
        this.addImageForm.patchValue({
          imageURL: this.imageURL
        })
      };
    }
  }

  upload(files) {
    if (this.addImageForm.invalid) {
      return;
    }
    if ((this.imagePath[0].type.indexOf("png")) < 0 && (this.imagePath[0].type.indexOf("jpeg")) < 0) {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.MESSAGE_INVALID_FILE.EXPECTED_JPG_OR_PNG'));
      return;
    }
    if (this.imagePath.length === 0) return;

    const value: ImageLibrary = this.addImageForm.value;
    const formData = new FormData();
    this.userData = this.appConfig.userData;
    var userId = this.userData.userId;
    formData.append("ImageURL", this.imagePath[0]);
    formData.append("imageName", value.imageName);
    formData.append("description", value.description);
    formData.append("tags", JSON.stringify(this.items));
    formData.append("createdBy", userId);

    this.layoutService.showLoader = true;
    this.service.createImage(formData).subscribe((res: Array<ImageLibrary>) => {
      this.layoutService.showLoader = false;
      // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.IMAGE_TO_LIBRARY'));
      // this.router.navigateByUrl('/configure/department', { skipLocationChange: true }).then(() =>
      // this.router.navigate(["configure/image-library"]));
      //res = this.ImageData;
      this.imageURL = null;
      this.collapseExample = false;
      this.getImageList();
    });
  }

  getImageList() {
    this.service.getImageById(this.appConfig.userData.userId, this.appConfig.userData.roleName.roleId, this.appConfig.userData.country).subscribe((res: Array<ImageLibrary>) => {
      this.ImageData = res;
    });
  }
  openDeleteModal(deletemodal: TemplateRef<any>) {
    this.deleteImage = this.ImageData[this.index];
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  removeImage() {
    this.service
      .deleteImage(this.deleteImage.imageLibraryID)
      .subscribe((res: Array<ImageLibrary>) => {
        //var data: Array<ImageLibrary> = JSON.parse(JSON.stringify(this.ImageData));
        var data: Array<ImageLibrary> = this.ImageData;
        this.ImageData = [];
        var index = data.findIndex(
          imageFile => imageFile.imageLibraryID === this.deleteImage.imageLibraryID
        );
        data.splice(index, 1);
        this.ImageData = data;
        this.collapseExample = false;
        this.imageURL = null;
        this.index = null;
        // this.router.navigateByUrl('/configure/department', { skipLocationChange: true }).then(() =>
        // this.router.navigate(["configure/image-library"]));
      });
  }
  editImage(image: ImageLibrary) {
    this.isPreview = false;
    this.imageId = image.imageLibraryID;
    this.addImageForm.patchValue({
      imageName: image.imageName,
      description: image.description,
      tags: JSON.parse(image.tags),
      ImageURL: image.imageURL
    });
    this.imageURL = image.imageURL;
    if (this.addImageForm.value.tags.length > 0) {
      for (let i = 0; i < this.addImageForm.value.tags.length; i++) {
        this.items.push(this.addImageForm.value.tags[i]);
      }
    }
  }

  updateImage(files) {
    const value: ImageLibrary = this.addImageForm.value;
    const formData = new FormData();
    this.userData = this.appConfig.userData;
    var userId = this.userData.userId;
    if (!this.imagePath ||this.imagePath.length <= 0) {
      formData.append("imageName", value.imageName);
      formData.append("description", value.description);
      formData.append("tags", JSON.stringify(this.items));
      formData.append("updatedBy", userId);
    } else {
      if (!this.imagePath) {
        this.imagePath = files;
      }
      if ((this.imagePath[0].type.indexOf("png")) < 0 && (this.imagePath[0].type.indexOf("jpeg")) < 0) {
        this.layoutService.showError(this.layoutService.translateText('CONFIGURE.MESSAGE_INVALID_FILE.EXPECTED_JPG_OR_PNG'));
        return;
      }
      formData.append("ImageURL", this.imagePath[0]);
      formData.append("imageName", value.imageName);
      formData.append("description", value.description);
      formData.append("tags", JSON.stringify(this.items));
      formData.append("updatedBy", userId);

    }
    this.layoutService.showLoader = true;
    this.service.updateImage(this.imageId, formData)
      .subscribe((res: Array<ImageLibrary>) => {
        this.layoutService.showLoader = false;
        // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.IMAGE_TO_LIBRARY'));
        // this.router.navigateByUrl('/configure/department', { skipLocationChange: true }).then(() =>
        // this.router.navigate(["configure/image-library"]));
        //res = this.ImageData;
        this.imagePath = null;
        this.imageId = null;
        this.imageURL = null;
        this.addImageForm.reset();
        this.collapseExample = false;
        this.getImageList();
      });
  }

  onInputTagKeyup(target: any): void {
    if (target.value == '' || target.value.length == 0) return;
    this.items.push({ value: target.value });
    target.value = '';
  }

  remove(tag: any): void {
    const index = this.items.indexOf(tag);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }
}
